import React, { useEffect, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import getEnvironement from '../../../environnement';
import axios from 'axios';
import CustomBackdrop from '../../../components/backdrop';
import { toast } from 'react-toastify';

export default function DeleteDialog({
  open,
  handleClose,
  reloadData,
  message,
  getNotificationData
}) {
  const [openBackdrop, setOpenBackdrop] = useState(false);

  async function deleteMessage() {
    const url = `${getEnvironement().API_URL}/messages/${message.id}`;
    handleClose();
    setOpenBackdrop(true);
    await axios.delete(url)
      .then(() => setTimeout(() => setOpenBackdrop(false), 1000))
      .then(() => reloadData())
      .then(() => getNotificationData())
      .then(() => toast.success(`Le message ${message?.id} a bien été supprimé`))
      .catch((err) => {
        setOpenBackdrop(false);
      });
  }

  return (
    <>
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackdrop} />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{paddingBottom: '0px'}}
      >
        <DialogTitle id="alert-dialog-title">
          <p className='text-2xl sm:text-3xl font-medium font-inter mt-5'>Message : {message?.id}</p>
          
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          <p className='text-2xl sm:text-3xl font-medium font-inter mt-5'>Voulez vous vraiment supprimer ce message. il sera supprimer définitivement</p>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <div className='flex justify-between px-5 w-full gap-5'>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={handleClose}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Annuler</p>
            </div>
            <div
              className='group rounded-[20px] py-2 sm:py-3 mb-5 cursor-pointer bg-primary hover:bg-primaryDark w-full'
              onClick={deleteMessage}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Supprimer</p>
            </div>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
